<script lang="ts">
import DebugStatsMeters from "./components/DebugStatsMeters.svelte";
import MapScreen from "./components/MapScreen/MapScreen.svelte";
import { Toaster } from "./components/ui/sonner/index.ts";
import { TooltipProvider } from "./components/ui/tooltip/index.ts";
</script>

<svelte:head>
  <title>MyMaps</title>
</svelte:head>

<TooltipProvider>
  <MapScreen />
</TooltipProvider>
<Toaster position="top-center" />
{#if import.meta.env.DEV}
  <DebugStatsMeters />
{/if}
